import { Grid } from '@material-ui/core'
import { Button, useNotify, useRefresh } from 'react-admin'
import Api from '../../../Apis/api.service'
import { useStyles } from '../styles'

export const OpenNext = ({
  setOpenResolutionId,
  setIsChanged,
  resolution,
  setOpen,
  open,
  ag,
}) => {
  const refresh = () => {
    setIsChanged((prev) => {
      let newVal = new Date().getTime()
      return newVal
    })
  }
  const notify = useNotify()
  const classes = useStyles()

  if (!resolution || !resolution.opened) return null

  const openNext = async () => {
    const result = await Api.ags3.update(ag.id, {
      open_next_resolution: true,
      open_resolution_id: resolution.id,
    })
    const { data } = result
    if (result.status === 200) {
      if (setOpenResolutionId) {
        setOpenResolutionId(data.open_resolution_id)
        setIsChanged((prev) => {
          let newVal = new Date().getTime()
          return newVal
        })
        setOpen(!open)
      } else refresh()
      notify('Résolution ouverte')
    } else {
      if (data.message === 2) {
        if (
          window.confirm(
            "Des copropriétaires enregistrés n'ont pas voté. Voulez-vous ouvrir une nouvelle résolution au vote malgré tout?"
          )
        ) {
          const result2 = await Api.ags3.update(ag.id, {
            open_next_resolution: true,
            force: true,
            open_resolution_id: resolution.id,
          })
          if (result2.status === 200) {
            if (setOpenResolutionId) {
              setOpenResolutionId(result2.data.open_resolution_id)
              setIsChanged((prev) => {
                let newVal = new Date().getTime()
                return newVal
              })
              setOpen(!open)
            } else refresh()
            notify('Résolution ouverte')
          } else {
            notify(`${result2.data.message}`, 'warning')
          }
        }
      } else {
        notify(`${data.message}`, 'warning')
      }
    }
  }

  return (
    <Grid item>
      <Button
        className={classes.actionButton}
        variant="contained"
        size="normal"
        color="secondary"
        label="Clôturer les votes et voter la suivante"
        onClick={openNext}
      />
    </Grid>
  )
}

export default OpenNext
